import _Snackbar from "@material-ui/core/esm/Snackbar";
import _SnackbarContent from "@material-ui/core/esm/SnackbarContent";
import React from 'react';
import classes from './snackbar.scss';
export const SnackBarComponent = ({
  err,
  open,
  message,
  dataDiv = 'Notification',
  onRequestClose
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Snackbar, {
    autoHideDuration: err ? 5000 : 3000,
    open: open,
    onClose: onRequestClose,
    "data-div": dataDiv
  }, /*#__PURE__*/React.createElement(_SnackbarContent, {
    message: message,
    classes: {
      root: err ? classes.error : classes.info,
      message: classes.message
    }
  })));
};